import { AEMMenuContent } from '../../models';

export const AemMenuContentMocks: AEMMenuContent = {
  menu: {
    sideNavigation: [
      {
        id: 'skyMiles',
        label: 'My SkyMiles',
        pagePath: '/myskymiles',
        details: [
          {
            id: 'overview',
            title: 'Overview',
            url: '/myskymiles/overview'
          },
          {
            id: 'account-activity',
            title: 'Account Activity',
            url: '/myskymiles/accountactivity'
          },
          {
            id: 'benefits',
            title: 'Member Benefits',
            url: '/overview#benefits'
          },
          {
            id: 'promotions',
            title: 'Promotions',
            url: '/myskymiles/promotions'
          },
          {
            id: 'businesstraveleroverview',
            title: 'Business Traveler Overview',
            url: '/myskymiles/businesstraveleroverview'
          },
          {
            id: 'partner-network',
            title: 'Partner Network',
            url: '/myskymiles/partner-network'
          },
          {
            id: 'buy-gift-transfer-donate-miles',
            title: 'Buy, Gift or Transfer Miles',
            url: '/us/en/skymiles/how-to-use-miles/buy-gift-transfer-donate-miles'
          }
        ]
      },
      {
        id: 'trips',
        label: 'My Trips',
        pagePath: '/mytrips/',
        details: []
      },
      {
        id: 'profile-2',
        label: 'My Profile',
        pagePath: '/profile',
        details: [
          {
            id: 'personal-details',
            title: 'Personal Details',
            url: '/my-profile/personal-details'
          },
          {
            id: 'preferences',
            title: 'Preferences',
            url: '/my-profile/preferences'
          },
          {
            id: 'loyalty-programs',
            title: 'Other Loyalty Programs',
            url: '/my-profile/loyalty-programs'
          },
          {
            id: 'companions',
            title: 'Companions',
            url: '/my-profile/companions'
          },
          {
            id: 'saved-searches',
            title: 'Saved Searches',
            url: '/my-profile/saved-searches'
          },
          {
            id: 'certificates',
            title: 'Certificates, eCredits & Vouchers',
            url: '/my-profile/certificates'
          },
          {
            id: 'payment-methods',
            title: 'Payment Methods',
            url: '/my-profile/payment-methods'
          },
          {
            id: 'security-settings',
            title: 'Password & Security Settings',
            url: '/my-profile/security-settings'
          }
        ]
      },
      {
        id: 'receipts',
        label: 'Receipts',
        pagePath: '/mydelta/walletMyReceiptSummary',
        details: []
      }
    ]
  }
};
